import React from 'react';
import { SelectedFlavorProps } from '../../../../../Atoms/ProductAtoms';
import { IProductListProduct } from '../../../../../../Interface/ProductList';
import ZoomImage from './ZoomImage/ZoomImage';

type ProductImageProps = {
  product: IProductListProduct;
  selectedFlavor?: SelectedFlavorProps;
};

const ProductImage = ({ product, selectedFlavor }: ProductImageProps) => {
  return (
    <div className="position-relative">
      <ZoomImage
        src={selectedFlavor?.flavorImages?.front_image_url || product.image_uri}
        product={product}
      />
    </div>
  );
};

export default ProductImage;
